"use client";

export { Modal as default } from "@aera/ui";
export type { ModalProps, ModalSize } from "@aera/ui";
export {
  ModalBody,
  ModalBodyContent,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  MODAL_HEADER_CLASSNAME,
} from "@aera/ui";
